import du from '../utils/dom-utilities';
import {cardThumbnailTpl} from '../templates/cardThumbnailTpl';

/**
 * Get data from card-thumbnail module and return a json
 *
 * @export
 * @param {HTMLElement} element Should be a card-thumbnail module
 * @returns {Object}
 */
export function _getDataFromNode(element) {
    var $image = element.querySelector('[data-card-thumbnail-imghd]');
    var title = element.querySelector('[data-card-thumbnail-title]').innerHTML;
    var subtitles = du.queryAll('[data-card-thumbnail-subtitle]', element).map((subtitleItem) => {
        return {
            poste:  subtitleItem.querySelector('[data-card-thumbnail-poste]').innerHTML,
            entreprise:  subtitleItem.querySelector('[data-card-thumbnail-entreprise]').innerHTML
        };
    });
    var description = element.querySelector('[data-card-thumbnail-desc]').innerHTML;
    return {
        image: $image.outerHTML || '',
        imageHD: $image.getAttribute('data-card-thumbnail-imghd') || '',
        imageSize: $image.getAttribute('data-card-thumbnail-imgsize') || '',
        btnlabel: $image.getAttribute('data-card-thumbnail-btnlabel') || '',
        title: title || '',
        subtitles: subtitles || '',
        description: description || ''
    };
}

/**
 * Css class to add on the lightbox container
 */
const lightboxContainerCssClasses = [
    'lightbox--white',
    'lightbox--mobilefull'
];

/**
 * Activate a pop-up with more details for card thumbnail
 *
 * @export
 * @param {string} selector
 * @param {lightbox} lightbox
 */
export default function cardThumbnail (selector = null, lightbox = null) {
    if (!selector || !lightbox) {
        throw new Error('selector param or lightbox param cannot be null.');
    }

    du.queryAll(selector).forEach((elem) => {
        var $button = elem.querySelector('[data-card-thumbnail-btn]');
        var data = _getDataFromNode(elem);

        du.onEvent($button, 'click', () => {
            lightbox.insertData(cardThumbnailTpl(data));
            lightbox.open(lightboxContainerCssClasses);
        });
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/cardThumbnail.js